import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import Box from '@mui/material/Box';
import is from '@sindresorhus/is';
import { Fragment, useContext } from 'react';

import { AmbitionList } from './AmbitionList';
import { ApplicationContext } from '../../../../../../../shared/source/context/context';
import { ContentHeadline, ContentWrapper } from '../../../../../design/components/containers/ContentWrapper';
import { useScrollToLocationHash } from '../../../../use-scroll-to-location-hash';
import { CardPlaceholder } from '../common/CardPlaceholder';

import type { Ambition } from '../../../../../../../shared/source/data-contract/ambition';
import type { FunctionComponent, ReactNode } from 'react';

type AmbitionContentProps = {
    readonly action?: ReactNode | undefined;
    readonly ambitions: readonly Ambition[] | undefined;
};

export const AmbitionContent: FunctionComponent<AmbitionContentProps> = ({ action, ambitions }) => {
    const { translate } = useContext(ApplicationContext);

    useScrollToLocationHash();

    return (
        <ContentWrapper>
            <Box
                id="ambitions"
                role="table"
                sx={{
                    position: 'relative',
                    top: -75,
                }}
            />
            <ContentHeadline actions={action} text={translate('pages.recruiter-profile.ambitions.title')} />
            <Fragment>
                {is.array(ambitions) && is.nonEmptyArray(ambitions) ? (
                    <AmbitionList ambitions={ambitions} />
                ) : (
                    <CardPlaceholder
                        placeholderIcon={<LanguageRoundedIcon />}
                        placeholderText={translate('pages.recruiter-profile.ambitions.placeholder')}
                    />
                )}
            </Fragment>
        </ContentWrapper>
    );
};
